import type { LucideIcon } from 'lucide-vue-next'
import type { ILocaleCode } from '.'

export interface IUserLoginAPI {
	/**
	 * User's password
	 */
	pwd: string
	/**
	 * User's email or username
	 */
	login: string
}

export enum SubscriptionType {
	Free = 0,
	Basic = 1,
	Pro = 2,
}

export interface IUser {
	/**
	 * User's id
	 */

	id: number

	/**
	 * User's username
	 */
	username: string

	/**
	 * User's email address
	 */
	email: string

	/**
	 * Flag indicating whether the user wants to receive updates
	 */
	keep_updated: boolean

	/**
	 * User's language
	 */
	lang: ILocaleCode

	/**
	 * User's generation token
	 */
	generation_token: number

	/**
	 * Account configured
	 */
	tag_setting_ack: boolean

	/**
	 * User's referral code (share)
	 */
	referral_code: string

	referrer_id: number | null
	plan: SubscriptionType
	pro_expire: string | null
	daily_token: number
	daily_quest_completed: boolean
}

/**
 * @description User Registration interface
 */
export interface IUserRegistration {
	/**
	 * Flag indicating whether the user wants to receive updates
	 */
	keep_updated: boolean

	/**
	 * User's language
	 */
	lang: ILocaleCode

	/**
	 * User's email address
	 */
	email: string
}

/**
 * @description User Registration interface (client-side)
 */
export interface IUserUpdate extends Omit<IUser, 'email' | 'referral_code'> {
	/**
	 * User's password
	 */
	pwd: string
}

/**
 * @description User Registration interface (server-side)
 */
export interface IUserUpdateAPI {
	/**
	 * User's password
	 */
	pwd?: string

	/**
	 * User data excluding the email field.
	 */
	user: Partial<Omit<IUser, 'email' | 'referral_code'>>
}

/**
 * Represents the title and icon of a user modal.
 */
export interface IUserModalTitle {
	title: string
	icon: string | LucideIcon
}

export interface ReferralUser {
	id: number
	username: string
	tickets: number
}
